export default {
  accountSettings: {},
  formData: {},
  emailSenders: [],
  users: [],
  tokenData:{},
  featurePage:[]
};
